(function () {
  const CHAT_WINDOW_NAME = "humanKineticsChatbot";
  const CHAT_URL = "/pages/human-kinetics-virtual-assistant";
  const width = 450;
  const height = 650;
  // Position it on the right side, with a small margin
  const left = window.screen.availWidth - width - 20; // 5px from right edge
  const top = window.screen.availHeight - height - 40; // 40px from bottom (adjust if needed)
  const CHAT_FEATURES = `toolbar=yes,scrollbars=yes,resizable=yes,width=${width},height=${height},top=${top},left=${left}`;
  const LOCAL_KEY = "chatWindowData";
  const SESSION_TAB_KEY = "chatTabId";

  // Create a stable tab id for this tab (persists across same-tab navigation)
  let TAB_ID = sessionStorage.getItem(SESSION_TAB_KEY);
  if (!TAB_ID) {
    TAB_ID = `${Date.now()}-${Math.random().toString(36).slice(2,9)}`;
    sessionStorage.setItem(SESSION_TAB_KEY, TAB_ID);
  }

  const channel = new BroadcastChannel(CHAT_WINDOW_NAME);
  let popup = null;
  let closeCheckInterval = null;

  function openChat() {
    const chatData = JSON.parse(localStorage.getItem(LOCAL_KEY) || "{}");

    // If a popup is already claimed open...
    if (chatData.isOpen) {
      if (chatData.ownerTabId === TAB_ID) {
        // SAME TAB → try to retrieve and focus the popup
        popup = window.open("", CHAT_WINDOW_NAME, CHAT_FEATURES);
        if (popup && !popup.closed) {
          try { popup.focus(); } catch (e) { console.warn("focus blocked", e); }
          return;
        } else {
          // Owner tab lost reference or popup closed unexpectedly — cleanup and reopen
          cleanupLocal();
          openNewPopup();
          return;
        }
      } else {
          if (chatData.isOpen) {
                // DIFFERENT TAB owns popup → ask that tab to focus and show alert
                //// Only show alert if another tab owns the popup and we can't focus it
                channel.postMessage({ type: "focus-request" });
               showAlertModal({
                         title: "Chat Window Already Open",
                       message: `Looks like you already have a chat window open in another tab.<br><br>
                                 Please return to that window to continue chatting.<br><br>
                                 <span style="font-size: 0.9em; color: #555;">
                                 Tip: Look for a window titled “Human Kinetics Virtual Assistant.”
                                 </span>`
                });
              }
        return;
      }
    }

    // No popup recorded as open → open a fresh one
    openNewPopup();
  }

  function openNewPopup() {
    popup = window.open(CHAT_URL, CHAT_WINDOW_NAME, CHAT_FEATURES);
    if (!popup || popup.closed) {
      showAlertModal({
                      title: "Popup Blocked",
                      message: `Your browser blocked the chat window from opening.<br><br>
                                Please allow popups for this site and try again.<br><br>
                                <span style="font-size: 0.9em; color: #555;">
                                 ${getPopupTip()}
                                </span>`,
          buttonText: "Got it"
      });
      return;
    }

    // Record ownership in localStorage
    const chatInfo = { isOpen: true, ownerTabId: TAB_ID, timestamp: Date.now() };
    localStorage.setItem(LOCAL_KEY, JSON.stringify(chatInfo));

    // Announce open
    channel.postMessage({ type: "opened", ownerTabId: TAB_ID });

    // Start monitoring closure to cleanup state
    if (closeCheckInterval) clearInterval(closeCheckInterval);
    closeCheckInterval = setInterval(() => {
      try {
        if (!popup || popup.closed) {
          cleanupLocal();
          clearInterval(closeCheckInterval);
          closeCheckInterval = null;
        }
      } catch (e) {
        // Accessing popup may throw if cross-origin closed — treat as closed
        cleanupLocal();
        clearInterval(closeCheckInterval);
        closeCheckInterval = null;
      }
    }, 400);
  }

  function cleanupLocal() {
    const stored = JSON.parse(localStorage.getItem(LOCAL_KEY) || "{}");
    // Only remove if this tab is owner or no owner present (safety)
    if (!stored.ownerTabId || stored.ownerTabId === TAB_ID) {
      localStorage.removeItem(LOCAL_KEY);
    } else {
      // If some other tab owns it, don't touch it
    }
    channel.postMessage({ type: "closed", ownerTabId: TAB_ID });
  }

  // React to messages from other tabs
  channel.onmessage = (event) => {
    const data = event.data || {};
    if (data.type === "focus-request") {
      // If this tab owns an open popup, focus it
      const stored = JSON.parse(localStorage.getItem(LOCAL_KEY) || "{}");
      if (stored.isOpen && stored.ownerTabId === TAB_ID) {
        popup = window.open("", CHAT_WINDOW_NAME, CHAT_FEATURES);
        if (popup && !popup.closed) {
          try { popup.focus(); } catch (e) { console.warn("focus blocked", e); }
        }
      }
    } else if (data.type === "closed") {
      // Some tab closed the popup — cleanup localStorage if stale
      const stored = JSON.parse(localStorage.getItem(LOCAL_KEY) || "{}");
      if (stored.ownerTabId === data.ownerTabId) {
        localStorage.removeItem(LOCAL_KEY);
      }
    } else if (data.type === "opened") {
      // Another tab opened the popup — nothing to do here, but ideal to sync UI
    }
  };

  // Expose the function globally to be used by your button
  window.showChat = openChat;

  // Optional: if you want a button to reflect open state across pages, you can
  // listen for storage events (happens when other tabs modify localStorage)
  window.addEventListener("storage", (e) => {
    if (e.key === LOCAL_KEY) {
      // update UI as needed
      // e.newValue === null -> closed; otherwise open info available
    }
  });
})();

function getBrowserName() {
  const userAgent = navigator.userAgent;
  if (/chrome|chromium|crios/i.test(userAgent)) return "Chrome";
  if (/firefox|fxios/i.test(userAgent)) return "Firefox";
  if (/safari/i.test(userAgent) && !/chrome|crios/i.test(userAgent)) return "Safari";
  if (/edg/i.test(userAgent)) return "Edge";
  return "your browser";
}
function getPopupTip() {
  const browser = getBrowserName();
  switch (browser) {
    case "Chrome":
      return "Tip: In Chrome, click the blocked popup icon in the address bar to allow it.";
    case "Firefox":
      return "Tip: In Firefox, a small icon appears in the address bar when a popup is blocked. Click it to allow popups.";
    case "Edge":
      return "Tip: In Edge, click the popup blocked icon in the address bar to allow the chat window.";
    case "Safari":
      return "Tip: In Safari, go to Preferences > Websites > Pop-up Windows and allow popups for this site.";
    default:
      return "Tip: Please check your browser settings to allow popups for this site.";
  }
}


function showAlertModal({title = "Alert", message = "", buttonText = "OK", onClose = null} = {}) 
{
  // Remove any existing modal first (avoid stacking)
  const existingModal = document.getElementById("customAlertModal");
  if (existingModal) existingModal.remove();

  // Create modal container
  const modal = document.createElement("div");
  modal.id = "customAlertModal";
  modal.innerHTML = `
    <div style="
      position: fixed;
      top: 0; left: 0;
      width: 100%; height: 100%;
      background: rgba(0,0,0,0.5);
      display: flex; justify-content: center; align-items: center;
      z-index: 9999;">
      <div style="
        background: white;
        border-radius: 10px;
        padding: 20px;
        max-width: 400px;
        text-align: center;
        box-shadow: 0 4px 10px rgba(0,0,0,0.3);
        animation: fadeIn 0.2s ease-in-out;
      ">
        <p><strong>${title}</strong></p>
        <p style="margin-bottom: 15px;text-align: left;">${message}</p>
        <button id="closeModalBtn" style="
          padding: 8px 16px;
          background-color: #0078d7;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        ">${buttonText}</button>
      </div>
    </div>
  `;

  // Add to DOM
  document.body.appendChild(modal);

  // Close logic
  document.getElementById("closeModalBtn").onclick = () => {
    modal.remove();
    if (typeof onClose === "function") onClose();
  };
}
